module.exports = __webpack_public_path__ + "static/media/next_nav_bar_icon_finity.d68c1b5c.svg";